<script>
  import firebase from 'firebase';
  import {fade} from 'svelte/transition';


  const loginWithGoogle = () => {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider);
  };

</script>


<div class="column center expand auth">
  <div class="logo" in:fade>BLABLA</div>

  <button in:fade={{delay: 1000}} on:click={loginWithGoogle}>Sign in with Google</button>
</div>

<style>
  .auth {
    height: 100%;
    background-color: black;
  }

  .logo {
    color: white;
    font-weight: 700;
    font-size: 3rem;
    margin-bottom: 40px;
  }

  button {
    color: white;
    font-size: 1rem;
    cursor: pointer;
    border: none;
    border-bottom: 1px solid white;
    padding: 8px;
    background: none;
  }
</style>